import IntegrationsApp from './pages/index.jsx';
import Integration from './pages/integrationPage/IntegrationPage.jsx';
import Integrations from './pages/Integrations/Integrations.jsx';

export const Layout = IntegrationsApp;
export { Integrations, Integration };
